import { APP_ENV, type AppEnv } from '@/types/env';

export enum FeatureFlagType {
  Empty = 'empty', // コメントアウト以外で隠したい時に使う。あまり多用しないように！
  Demo = 'demo', // デモ用機能
  InventoryLot = 'inventory-lot', // 在庫のロット管理(#2540)
  ProductSample = 'product-sample', // 商品のサンプル(#8105)
}

const FeatureFlagConfig: Record<FeatureFlagType, AppEnv[]> = {
  [FeatureFlagType.Empty]: [],
  [FeatureFlagType.Demo]: ['development', 'staging'],
  [FeatureFlagType.InventoryLot]: ['development', 'staging'],
  [FeatureFlagType.ProductSample]: ['development', 'staging'],
};

export const isEnabledFeature = (flag: FeatureFlagType): boolean => {
  const allowedEnvs = FeatureFlagConfig[flag] ?? [];
  return allowedEnvs.includes(APP_ENV);
};
